// Order Constants

export const ORDER_DETAILS_REQUEST = 'ORDER_DETAILS_REQUEST';
export const ORDER_DETAILS_SUCCESS = 'ORDER_DETAILS_SUCCESS';
export const ORDER_DETAILS_FAIL = 'ORDER_DETAILS_FAIL';


export const ORDER_LIST_VENDEUR_SUCCESS = 'ORDER_LIST_VENDEUR_SUCCESS';
export const ORDER_LIST_VENDEUR_FAIL = 'ORDER_LIST_VENDEUR_FAIL';
// src/constants/orderConstants.js

export const ORDER_LIST_VENDEUR_REQUEST = 'ORDER_LIST_VENDEUR_REQUEST';


export const SHIPPING_ESTIMATE_REQUEST = 'SHIPPING_ESTIMATE_REQUEST';
export const SHIPPING_ESTIMATE_SUCCESS = 'SHIPPING_ESTIMATE_SUCCESS';
export const SHIPPING_ESTIMATE_FAIL = 'SHIPPING_ESTIMATE_FAIL';
export const SHIPPING_ESTIMATE_RESET = 'SHIPPING_ESTIMATE_RESET';
